interface VehicleDetails {
    id: number;
    name: string;
    vehicle_number: string;
    seats_capacity: number;
    occupied_seats: number;
    vehicle_status: string;
    vehicle_schedule_id: number;
    route_id: number;
    driver_id: string;
    driver_name: string;
    driver_status: string;
    schedule_status: string;
}

export interface IVehicleOnBoardState {
    data: VehicleDetails[];
}

export enum IVehicleOnBoardActionTypes {
    FETCH_VEHICLES_LIST_REQUEST = 'FETCH_VEHICLES_LIST_REQUEST',
    FETCH_VEHICLES_LIST_SUCCESS = 'FETCH_VEHICLES_LIST_SUCCESS',
    FETCH_VEHICLES_LIST_FAILURE = 'FETCH_VEHICLES_LIST_FAILURE',

    FETCH_DRIVERS_LIST_REQUEST = 'FETCH_DRIVERS_LIST_REQUEST',
    FETCH_DRIVERS_LIST_SUCCESS = 'FETCH_DRIVERS_LIST_SUCCESS',
    FETCH_DRIVERS_LIST_FAILURE = 'FETCH_DRIVERS_LIST_FAILURE',


    ADD_VEHICLE_REQUEST = 'ADD_VEHICLE_REQUEST',
    ADD_VEHICLE_SUCCESS = 'ADD_VEHICLE_SUCCESS',
    ADD_VEHICLE_FAILURE = 'ADD_VEHICLE_FAILURE',
    RESET_ADD_VEHICLE_STATE = 'RESET_ADD_VEHICLE_STATE',

    DELETE_VEHICLE_REQUEST = 'DELETE_VEHICLE_REQUEST',
    DELETE_VEHICLE_REQUEST_SUCCESS = 'DELETE_VEHICLE_REQUEST_SUCCESS',
    DELETE_VEHICLE_REQUEST_FAILURE = 'DELETE_VEHICLE_REQUEST_FAILURE',

    ADD_STOP_REQUEST = 'ADD_STOP_REQUEST',
    ADD_STOP_SUCCESS = 'ADD_STOP_SUCCESS',
    ADD_STOP_FAILURE = 'ADD_STOP_FAILURE',
    RESET_ADD_STOP_STATE = 'RESET_ADD_STOP_STATE',
}

export type IVehicleOnBoardActionCreator = {
    type: string;
    payload: IVehicleOnBoardState;
  };